module.exports = __webpack_public_path__ + "assets/images/spor_fm_tv1_logo.f412b10ba301f5feda74c9723f5e92ce.png";